export default __webpack_public_path__ + "static/media/trus1.394ab7e5.png";